// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type RootUserState } from '@shared/data-access/interfaces/redux';
import { createTypedSelector } from '@shared/data-access/utils';

const createSelector = createTypedSelector<RootUserState>();

export const selectUserState = (state: RootUserState) => state.user;

export const selectAccountCurrency = createSelector(
  selectUserState,
  ({ accountCurrency }) => accountCurrency,
);

export const selectExpirationDate = createSelector(
  selectUserState,
  ({ expiration_date }) => expiration_date,
);

export const selectUserStatus = createSelector(
  selectUserState,
  ({ status }) => status,
);

export const selectOrganizations = createSelector(
  selectUserState,
  ({ organizations }) => organizations,
);

export const selectAdminOrganizations = createSelector(
  selectOrganizations,
  organizations => organizations.filter(org => org.flag_admin),
);

export const selectLoginType = createSelector(
  selectUserState,
  ({ loginType }) => loginType,
);

export const selectIsOrgLogin = createSelector(
  selectLoginType,
  /* istanbul ignore next */
  loginType => loginType?.is_organization,
);

export const selectUserBase = createSelector(
  selectUserState,
  ({ userBase }) =>
    userBase ?? {
      first_name: null,
      second_name: null,
      first_surname: null,
      second_surname: null,
      phone_number: null,
      user_id: null,
    },
);

export const selectUserId = createSelector(selectUserBase, state => state.user_id);

export const selectRole = createSelector(selectUserState, ({ role }) => role);
